var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "General webhook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6371F7",
    d: "M12 2a7 7 0 00-3.5 13.06V17a1.5 1.5 0 001.5 1.5h4A1.5 1.5 0 0015.5 17v-1.94A7 7 0 0012 2zm0 2a5 5 0 011 9.9V17h-2v-3.1A5 5 0 0112 4zM8.5 19.5h7v1h-7v-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.fcccda3e.svg";
export { ForwardRef as ReactComponent };